import React from 'react';
import Modal from '../Modal';
import { Icon } from '../Icon';
import { CustomButton } from '../Button/Button';
import styles from './WarningNotification.module.scss';
import { useTranslation } from 'react-i18next';

const WarningNotification = ({ open, onClose, title, text, btnText, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Modal className={styles.modal} onClose={onClose} open={open}>
      <div className={styles.modalHeader}>
        <div className={styles.modalTitle}>{title}</div>
        <div className={styles.closeBtn} onClick={onClose}>
          <Icon className={styles.icon} src="close" />
        </div>
      </div>
      <div className={styles.modalContent}>
        <div className={styles.modalText}>{text}</div>
      </div>
      <div className={styles.modalFooter}>
        <CustomButton className={styles.cancelBtn} variant="secondary" label={t('general.cancel')} onClick={onClose} />
        <CustomButton label={btnText} variant="primary" onClick={onSubmit} />
      </div>
    </Modal>
  );
};

export default WarningNotification;
